'use client'

import { FC } from 'react'
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'

import Icon from '~/src/components/generic/PhosphorIcons/Icon'
import IconButton from '~/src/components/generic/IconButton'

import colors from '~/config/colorsScheme'

type Props = {
  isOpen: boolean
  onClose: () => void
  guideUrl: string
}

const SidePanel: FC<Props> = ({ isOpen, onClose, guideUrl }) => {
  return (
    <div>
      <Dialog
        className="relative z-50"
        data-testid="side-panel-dialog"
        open={isOpen}
        onClose={onClose}
      >
        <DialogBackdrop
          className="fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0 dark:bg-gray-900/50"
          transition
        />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
              <DialogPanel
                className="pointer-events-auto w-screen max-w-3xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                transition
              >
                <div className="relative flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl">
                  <div className="px-4 sm:px-6">
                    <div className="flex items-start justify-between">
                      <IconButton
                        aria-label="Close use guide"
                        variant="ghost"
                        onClick={onClose}
                      >
                        <Icon color={colors.gray[700]} name="XIcon" size="20" />
                      </IconButton>
                    </div>
                  </div>

                  <div className="">
                    <iframe
                      className="h-screen w-full"
                      loading="lazy"
                      src={guideUrl}
                      title="Embedded Notion page"
                    />
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default SidePanel
